async function registerGA(params){
    let dataLayer = window.dataLayer || [];
    dataLayer.push(params);
}

export { registerGA };